export const isNumber = value => /^[+*#0-9 ]+$/.test(value);
